var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFiled(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "filed",
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.104,
    height: 24,
    viewBox: "0 0 22.104 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5297",
    "data-name": "Group 5297"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9044",
    "data-name": "Path 9044",
    d: "M12.536,17.979h0l1.32,1.814-2.557.495Zm.495-.33,7.753-5.443,1.32,1.9-7.835,5.443ZM3.216,4.784a.536.536,0,1,1,0-1.072H16.33a.538.538,0,0,1,0,1.072Zm0,2.639a.578.578,0,0,1,0-1.155H16.33c.66,0,.66,1.155,0,1.155Zm0,2.557a.578.578,0,0,1,0-1.155H16.33c.66,0,.66,1.155,0,1.155Zm0,2.557a.578.578,0,0,1,0-1.155H16.33c.66,0,.66,1.155,0,1.155Zm0,2.557a.578.578,0,0,1,0-1.155h9.4a.578.578,0,0,1,0,1.155ZM1.732,0H18.227a1.674,1.674,0,0,1,1.649,1.732V12.371L18.8,13.2V1.732a.708.708,0,0,0-.577-.66H1.732a.71.71,0,0,0-.66.66V22.268a.637.637,0,0,0,.66.577H18.227a.62.62,0,0,0,.577-.577V16.99l1.072-.742v6.021A1.674,1.674,0,0,1,18.227,24H1.732A1.691,1.691,0,0,1,0,22.268V1.732A1.691,1.691,0,0,1,1.732,0Z",
    fill: "#fff",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFiled);
export default __webpack_public_path__ + "static/media/filed.50b254d3560eaf1227c78342a580873e.svg";
export { ForwardRef as ReactComponent };